import { createReducer } from '@reduxjs/toolkit';
import { handleActionStart, handleActionError } from 'store/utils';
import {
  setCurrentPatient,
  clearCurrentPatient,
} from 'store/currentPatient/actions';

import { fetchFhirCommunications } from 'store/currentPatient/actions/fhir';

const initialState = {
  data: [],
  isLoading: false,
  error: null,
};

export default createReducer(initialState, {
  [fetchFhirCommunications.STARTED]: handleActionStart,
  [fetchFhirCommunications.SUCCEEDED]: (state, action) => {
    state.isLoading = false;
    state.error = null;
    state.data = action.payload;
  },
  [fetchFhirCommunications.FAILED]: handleActionError,
  [setCurrentPatient]: (_, action) => action.payload.communications,
  [clearCurrentPatient]: () => initialState,
});
